module.exports = __webpack_public_path__ + "img/appAsset-brand--khipu.b4c3cd99.svg";